export const QA_NAME_REQUEST_PROFILE_EMAIL_THREAD_MODAL =
  'request_profile_email_thread_modal'
